import { onlyCnpjChars, validateCNPJ } from '../../../shared/utils/validators';
import type { BankAccountPayload, CreateCompanyPayload } from '../api';

export type CompanyFormValues = {
  corporateName: string;
  tradeName: string;
  cnpj: string;
  responsibleName: string;
  responsibleEmail: string;
  responsiblePhone: string;
};

export function validateCompanyForm(values: CompanyFormValues): Partial<Record<keyof CompanyFormValues, string>> {
  const errors: Partial<Record<keyof CompanyFormValues, string>> = {};
  if (!values.corporateName.trim()) errors.corporateName = 'Razão social é obrigatória';
  if (!values.tradeName.trim()) errors.tradeName = 'Nome fantasia é obrigatório';
  if (!values.cnpj.trim()) errors.cnpj = 'CNPJ é obrigatório';
  else if (!validateCNPJ(values.cnpj)) errors.cnpj = 'CNPJ inválido. Verifique os dígitos verificadores.';
  if (!values.responsibleName.trim()) errors.responsibleName = 'Nome do responsável é obrigatório';
  if (!values.responsibleEmail.trim()) errors.responsibleEmail = 'E-mail do responsável é obrigatório';
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.responsibleEmail)) {
    errors.responsibleEmail = 'E-mail inválido';
  }
  if (!values.responsiblePhone.trim()) errors.responsiblePhone = 'Telefone do responsável é obrigatório';
  else if (!/^\d{10,11}$/.test(values.responsiblePhone.replace(/\D/g, ''))) {
    errors.responsiblePhone = 'Telefone inválido';
  }
  return errors;
}

export function normalizeCompanyForm(values: CompanyFormValues): CreateCompanyPayload {
  return {
    corporateName: values.corporateName.trim(),
    tradeName: values.tradeName.trim(),
    cnpj: onlyCnpjChars(values.cnpj),
    responsibleName: values.responsibleName.trim(),
    responsibleEmail: values.responsibleEmail.trim(),
    responsiblePhone: values.responsiblePhone.trim(),
  };
}

export function validateBankAccount(values: BankAccountPayload): Partial<Record<keyof BankAccountPayload, string>> {
  const errors: Partial<Record<keyof BankAccountPayload, string>> = {};
  if (!values.bankName.trim()) errors.bankName = 'Banco é obrigatório';
  if (!values.bankAgency.trim()) errors.bankAgency = 'Agência é obrigatória';
  else if (!/^\d{1,6}$/.test(values.bankAgency)) errors.bankAgency = 'Agência deve conter de 1 a 6 números';
  if (!values.bankAccount.trim()) errors.bankAccount = 'Conta é obrigatória';
  else if (!/^\d{1,20}$/.test(values.bankAccount)) errors.bankAccount = 'Conta deve conter de 1 a 20 números';
  if (!values.accountType) errors.accountType = 'Tipo de conta é obrigatório';
  return errors;
}

export function normalizeBankAccount(values: BankAccountPayload): BankAccountPayload {
  return {
    bankName: values.bankName.trim(),
    bankAgency: values.bankAgency.trim(),
    bankAccount: values.bankAccount.trim(),
    accountType: values.accountType,
    pixKey: values.pixKey?.trim() || undefined,
  };
}
